import * as apiSW from 'api/menuPlanner/GetMenuPlannerStartingWithV1';
import * as api from 'api/menuPlanner/PostMenuPlannerSearchV1';
import * as apiTracking from 'apiAuto/backend/paths/GetMenuPlannerGetTrackingDatatrackingV1';
import * as apiStatuses from 'apiAuto/backend/paths/PostMenuPlannerGetMenuPlannerStatusesV1';
import MenuPlan from 'classes/MenuPlan/Search/MenuPlan';
import { Optional } from 'functions/promiseExtensions';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class MenuPlanList {
	public all: MenuPlan[] = [];
	public filtered: ISelectItem[] = [];
	public totalCount: number = 0;

	public async search(searchTerm: string, showOnlyDeleted: boolean): Promise<void> {
		const response = await apiSW.apiCall(searchTerm, showOnlyDeleted);
		response.hasValue() && this.mapFromApiSW(response.get());
	}

	public async callApi(
		input: api.Request,
		withSubNodes: boolean = false
	): Promise<Optional<api.ResponseData>> {
		return await api.apiCall(input, withSubNodes);
	}

	public mapFromApi(input: api.ResponseData): void {
		this.totalCount = input.totalCount;
		this.all = [];
		for (const i of input.data) {
			const menuPlan: MenuPlan = new MenuPlan(i);
			this.all.push(menuPlan);
		}
	}

	public mapFromApiSW(input: apiSW.ResponseMenuPlanner[]): void {
		this.filtered = [];
		for (const i of input) {
			this.filtered.push({
				id: i.id,
				name: i.description,
			});
		}
	}

	public async getPublishStatuses(): Promise<void> {
		const ids: string[] = this.all.map((x) => x.id);

		if (ids.length === 0) {
			return;
		}

		const response = await apiStatuses.callApi({
			requestBody: ids,
		});
		response.do((statuses) => {
			this.all.forEach((menuPlan) => {
				const status = statuses.find((x) => x.menuPlannerId === menuPlan.id);
				if (!status) return;
				menuPlan.publishStatus = status.state;
				menuPlan.isChild = status.isChild;
			});
		});
	}

	public async getTrackingData(): Promise<void> {
		const ids: string[] = this.all.map((x) => x.id);

		if (ids.length === 0) {
			return;
		}

		const response = await apiTracking.callApi({
			requestBody: ids,
		});
		response.do((data) => {
			this.all.forEach((menuPlan) => {
				const child = data.find((x) => {
					if (x.childMenuPlannerId === menuPlan.id) {
						return true;
					}
				});
				if (child) menuPlan.location = child.location;
			});
		});
	}

	public findById(id: string): MenuPlan | undefined {
		return this.all.find((e) => e.id === id);
	}
}
